import manageSchema from '../model/schema';
import { assertOk, takeData } from '../../misc/api-utils';
import { authFactory, urlApiFactory } from '../model/factory';

export const PATHNAME = '/api/Core/User';

export const schema = manageSchema.pick({
  envJWTToken: true,
  hostApi: true,
  eventId: true
}).required();

export const fetchGet = (params) => async () => {
  const prms = schema.parse(params);
  const url = urlApiFactory(prms);
  url.pathname = PATHNAME;
  url.searchParams.append('eventid', prms.eventId);
  const headers = {
    Authorization: authFactory(prms)
  };

  const req = new Request(url, { headers });
  return fetch(req)
    .then(assertOk)
    .then(takeData);
};
